import BtagTemplate from "./BtagTemplate";
import useDebounce from "../../../../system/hooks/useDebounce";
import {
  usePagination,
  usePaginationPageSize,
} from "../../../../system/hooks/usePagination";
import { useMemo, useState } from "react";
import { useBtagStatsList } from "../../api/apiHooks";
import { FILTER_DEBOUNCE_DELAY } from "../../../ActionLogs/constants";
import { buildFilter } from "../../../../system/helpers/urlHelper";

const BtagContainer = () => {
  const [filter, setFilter] = useState({ "filter[search]": "" });
  const { page, setPage } = usePagination(1);
  const { pageSize, setPageSize } = usePaginationPageSize();
  const builtFilter = useMemo(() => buildFilter(filter), [filter]);

  const { data: dataSource, isFetching } = useBtagStatsList(
    useDebounce(builtFilter, FILTER_DEBOUNCE_DELAY),
    page,
    pageSize
  );

  const updateFilter = (val) => {
    setFilter({ "filter[search]": val });
    setPage(1);
  };

  return (
    <BtagTemplate
      data={dataSource}
      setPageSize={setPageSize}
      isLoading={isFetching}
      filter={filter}
      setFilter={updateFilter}
      setPage={setPage}
      currentPage={page}
    />
  );
};

export default BtagContainer;
